'use strict';

module.exports = {
    Scheduled: 'SCHEDULED',
    Pending: 'PENDING',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED',
    Failed: 'FAILED',
    Error: 'ERROR',
    RetryError: 'RETRY_ERROR'
};